// URL Encoder / Decoder Tool — percent-encode and decode text and URLs.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const urlEncoderTool: Tool = {
  id: "url-encoder",
  name: () => m.ue_tool_name(),
  description: () => m.ue_tool_description(),
  icon: "🔗",
  basePath: "/url-encode",
  status: "stable",
  tags: ["url", "encode", "decode", "developer"],
  pages: [
    {
      name: () => m.ue_nav_main(),
      path: "/url-encode",
      description: () => m.ue_nav_main_desc(),
      icon: "🔗",
    },
  ],
};
